import { render, staticRenderFns } from "./deleteOrder.vue?vue&type=template&id=2f379139&scoped=true&"
import script from "./deleteOrder.vue?vue&type=script&lang=js&"
export * from "./deleteOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f379139",
  null
  
)

export default component.exports